import { mixins } from 'vue-class-component'
import { Component, Watch } from 'vue-property-decorator'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSimpleButton from '@/components/AppSimpleButton.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { utcDateTimeToLocal } from '@/utils/dateTime'
import { showErrors, showNotification } from '@/utils/snack'
import AppTab from '@/components/AppTab.vue'
import DealerDialog from '../DealerList/script-dialog'
import { DealerModel } from '@/interfaces/dealer'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import AppAutoComplete from '@/components/AppAutoComplete.vue'
import AppFormItem from '@/components/AppFormItem.vue'
import { SchoolModel } from '@/interfaces/school'
import { updateDealerSchools, assignGoodsToDealer, removeGoodsFromDealer } from './gql'
import { SnackType } from '@/interfaces/snack'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import { GoodsStatusText } from '@/helpers/goods'
import AppTextarea from '@/components/AppTextarea.vue'
import { TypedGqlError } from '@/interfaces/error'
import AuthFilter from '@/mixins/auth-filter'
import { Goods, GoodsOrderBy } from '@/interfaces/goods'
import DealerOrders from './script-orders'
import { findGoods } from '../GoodsList/gql'
import { formatCurrency } from '@/utils/currency'

Component.registerHooks([
  'beforeRouteLeave'
])

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleButton,
    AppTab,
    AppSimpleDistrictSelector,
    AppAutoComplete,
    AppFormItem,
    AppSearchBtn,
    AppTextarea

  }
})

export default class DealerDetail extends mixins(DealerDialog, AuthFilter, DealerOrders) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '经销商管理'
    },
    {
      text: '经销商',
      to: { name: 'DealerList' }
    }

  ]

  formatCurrency = formatCurrency

  items = ['小店商品', '经营学校']
  activeTab = 0
  disableConfirm = false

  dealer: DealerModel | null = null
  targetSchool: SchoolModel | null = null
  targetGoods: any
  GoodsStatusText = GoodsStatusText
  windowSize = {
    w: 0,
    h: 0
  }

  actionsHeight = 51

  dealerId = ''
  dealerName = ''

  loading = false
  goodsLoading = false
  searchLoading = false
  schools: any = []
  goods: any = []
  headers = [
    { text: '学校名称', value: 'name', sortable: false, width: 300 },
    { text: '地区', value: 'area.mergerName', sortable: false },
    { text: '操作', value: 'actions', sortable: false, align: 'end' }
  ]

  goodsHeaders = [
    { text: '封面', value: 'good.thumb', sortable: false },
    { text: 'ISBN', value: 'good.isbn', sortable: false },
    { text: '商品标题', value: 'good.title', sortable: false },
    { text: '作者', value: 'good.author', sortable: false },
    { text: '出版社', value: 'good.press', sortable: false },
    { text: '本店价格', value: 'price', sortable: false },
    { text: '佣金比例', value: 'sharingProportion', sortable: false },
    { text: '状态', value: 'good.status', sortable: false },
    { text: '顺序', value: 'order', sortable: false },
    { text: '操作', value: 'actions', sortable: false, align: 'end' }
  ]

  searchHeaders = [
    { text: '封面', value: 'thumb', width: 80, sortable: false },
    { text: '商品标题', width: 270, value: 'title', sortable: false },
    { text: '价格', value: 'price', sortable: false }
  ]

  options = {
    itemsPerPage: 500
  }

  goodsOptions = {
    itemsPerPage: 500,
    sortDesc: [true]
  }

  utcDateTimeToLocal = utcDateTimeToLocal

  addGoods = {
    title: '添加商品',
    show: false
  };

  filter = { title: '' };

  allGoods: Goods[] = [];
  selectedGoods: Goods[] = [];

  get isPass () {
    return this.targetDealer?.status === 'APPROVED'
  }

  get filterGoods () {
    if (this.allGoods?.length !== 0) {
      return this.allGoods?.filter((item) => {
        return !this.goods?.some((ele: any) => ele.goodId === item.id)
      })
    } else {
      return []
    }
  }

  @Watch('targetDealer.goodRelations', { deep: true, immediate: true })
  goodRelationsChange (val: any) {
    if (val && val.length !== 0) {
      const goods = val.map((item: any) => {
        if (!item.price) {
          item.price = item.good.price
        }
        if (!item.details) {
          item.details = item.good.details
        }
        return item
      })

      const goodsArr: any = []

      if (this.displayOrders.length !== 0) {
        this.displayOrders.forEach((id) => {
          goods.forEach((item: any) => {
            if (item.goodId === id) {
              goodsArr.push(item)
            }
          })
        })
        this.goods = goodsArr.map((item: any, index: number) => {
          return {
            ...item,
            order: index + 1
          }
        })
      }
    }
  }

  async mounted () {
    if (this.getRole() === 'dealer') {
      this.goodsHeaders.pop()
    }
    this.onResize()
    const activeTab = sessionStorage.getItem('activeTab')
    if (activeTab) {
      this.activeTab = +activeTab
    }
    await this.getGoodsOrders()
    if (this.getRole() === 'dealer') {
      this.headers.pop()
    }
    const { id } = this.$route.params
    this.dealerId = id
    this.targetDealer = await this.getDealerById(Number(this.dealerId))
    this.schools = this.targetDealer?.schools
    this.dealerId = this.targetDealer?.id + ''
    this.dealerName = this.targetDealer?.realname + ''
    this.breadcrumbs.push({ text: `${this.dealerName}` })
  }

  async deleteConfirm () {
    await this.deleteDealerById()
    this.$router.push({
      name: 'DealerList'
    })
  }

  // 切换tab
  changeTab (val: number) {
    this.activeTab = val
  }

  async handleAudit (index: number) {
    switch (index) {
      case 0:
        await this.auditDealer(this.AuditStatus.APPROVED)
        this.targetDealer = await this.getDealerById(Number(this.dealerId))
        break
      case 1:
        this.denyDialog.show = true
        break
      default:
    }
  }

  async denyConfirm () {
    await this.auditDealer(this.AuditStatus.REJECT)
    this.denyDialog.show = false
    this.targetDealer = await this.getDealerById(Number(this.dealerId))
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  // 编辑小店商品
  editDealerGoods () {
    this.$router.push({
      name: 'EditDealerGoods',
      params: {
        id: this.dealerId
      }
    })
  }

  addManageSchoolDialog = {
    show: false,
    title: '添加学校'
  }

  allSchools = []
  addManageSchoolForm = {
    area: null,
    filterSchools: [],
    selectedSchools: []
  }

  // 添加学校
  addManageSchool () {
    this.$router.push({
      name: 'EditDealerSchool',
      params: {
        id: this.dealerId,
        name: this.dealerName
      }
    })
  }

  deleteDealerSchoolsDialog = {
    show: false,
    text: ''
  }

  deleteDealerGoodsDialog = {
    show: false,
    text: ''
  }

  // 确认删除经销商管理的学校
  async deleteDealerSchoolsConfirm () {
    const updateSchools = this.schools.filter((i: SchoolModel) => {
      return i.id !== this.targetSchool?.id
    })
    const schoolIds = updateSchools.map((item: SchoolModel) => {
      return item.id
    })
    try {
      const result = await this.$apollo.query({
        query: updateDealerSchools,
        variables: {
          dealerId: +this.dealerId,
          schoolIds
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功',
          type: SnackType.Info
        })
        const dealer = await this.getDealerById(Number(this.dealerId))
        this.schools = dealer.schools
        this.deleteDealerSchoolsDialog.show = false
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 显示删除学校弹框
  async deleteDealerSchools (item: SchoolModel) {
    this.deleteDealerSchoolsDialog.show = true
    this.deleteDealerSchoolsDialog.text = `是否删除学校：${item.name}?`
    this.targetSchool = item
  }

  // 显示删除学校弹框
  async deleteDealerGoods (item: any) {
    this.deleteDealerGoodsDialog.show = true
    this.deleteDealerGoodsDialog.text = `是否删除商品：${item.good.title}?`
    this.targetGoods = item
  }

  // 跳转book详情
  routeToGoodsDetail (item: any) {
    if (this.getRole() !== 'dealer') {
      this.$router.push({
        name: 'EditGoods',
        params: {
          id: item.goodId,
          dealerId: this.targetDealer?.id + '',
          dealer: JSON.stringify(item),
          isFromDealer: 'yes'
        }
      })
    }
  }

  filterQuerySubmit () {
    this.getGoodsByTitle()
  }

  addGoodsCancel () {
    this.filter.title = ''
    this.selectedGoods = []
    this.allGoods = []
  }

  // 确认添加商品
  async addGoodsConfirm () {
    if (!this.selectedGoods) {
      showNotification({
        msg: '请选择商品',
        type: SnackType.Error
      })
      return false
    } else {
      const goods = this.selectedGoods?.map((item: Goods) => {
        return {
          goodId: item.id
        }
      })
      try {
        const result = await this.$apollo.mutate({
          mutation: assignGoodsToDealer,
          variables: {
            dealerId: Number(this.dealerId + ''),
            goods
          }
        })
        if (result) {
          this.addGoods.show = false
          this.filter.title = ''
          this.selectedGoods = []
          this.allGoods = []
          showNotification({
            msg: '添加成功',
            type: SnackType.Info
          })
          await this.getGoodsOrders()
          this.targetDealer = await this.getDealerById(Number(this.dealerId))
        } else {
          showNotification({
            msg: '添加失败',
            type: SnackType.Error
          })
        }
      } catch (e) {
        const typedError = e as TypedGqlError
        showErrors(typedError.graphQLErrors)
      }
    }
  }

  // 搜索
  async getGoodsByTitle () {
    this.searchLoading = true
    try {
      const result = await this.$apollo.query({
        query: findGoods,
        variables: {
          order: {
            by: GoodsOrderBy.title,
            asc: true
          },
          paging: {
            skip: 0,
            take: 1000
          },
          where: {
            title: this.filter.title
          }
        }
      })
      if (result) {
        this.allGoods = result.data.findGoods.goods
        this.searchLoading = false
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 删除商品
  async deleteDealerGoodsConfirm () {
    const goodIds = []
    goodIds.push(this.targetGoods.goodId)
    try {
      const result = await this.$apollo.mutate({
        mutation: removeGoodsFromDealer,
        variables: {
          dealerId: +this.dealerId,
          goodIds
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功',
          type: SnackType.Info
        })
        this.deleteDealerGoodsDialog.show = false
        this.targetDealer = await this.getDealerById(Number(this.dealerId))
        this.goods = this.targetDealer?.goodRelations
        await this.getGoodsOrders()
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 导出
  exportHandler () {
    // todo
  }

  beforeRouteLeave (from: any, to: any, next: any) {
    sessionStorage.setItem('activeTab', this.activeTab + '')
    next()
  }
}
